import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  QueryReturnType,
  mutatePutFn,
} from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface DisputedKeysFilters {
  page?: number;
  limit?: number;
  /** open (default) | resolved | all */
  state?: string;
}

/**
 * GET /admin/disputes — the chargeback queue (Disputes collection). Each row has
 * the amount, reason, live Stripe status and the evidence deadline; `state`
 * filters open vs. admin-resolved.
 */
export const useGetDisputedKeys = (
  filters: DisputedKeysFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.DISPUTED_KEYS, { ...filters, state: filters.state || undefined }],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};

/** PUT /admin/disputes/:id/resolve — mark a dispute actioned (clears it from the open queue). */
export const useResolveDispute = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, note }: { id: string; note?: string }) =>
      mutatePutFn(ENDPOINTS.DISPUTE_RESOLVE.replace(":id", id), { note }),
    {
      onSuccess: () => {
        qc.invalidateQueries([ENDPOINTS.DISPUTED_KEYS]);
      },
    }
  );
};
